import { render } from "./insure-daily-claim.vue?vue&type=template&id=37d93b26&scoped=true&ts=true"
import script from "./insure-daily-claim.vue?vue&type=script&lang=ts"
export * from "./insure-daily-claim.vue?vue&type=script&lang=ts"

import "./insure-daily-claim.vue?vue&type=style&index=0&id=37d93b26&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d93b26"]])

export default __exports__